var AuthService = /** @class */ (function () {
    function AuthService(http) {
    }
    Object.defineProperty(AuthService.prototype, "authenticated", {
        get: function () {
            return localStorage.getItem('jwt') != null;
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.login = function (credentials) {
    };
    return AuthService;
}());
export { AuthService };
//# sourceMappingURL=auth.service.js.map